module.exports = __webpack_public_path__ + "static/media/03.7b194cfd.jpg";